export const SALESMAN_GET_REQUEST = "@salesman.get.request";
export const SALESMAN_GET_SUCCESS = "@salesman.get.success";
export const SALESMAN_GET_FAIL = "@salesman.get.fail";

export const SALESMAN_LOAD_REQUEST = "@salesman.load.request";
export const SALESMAN_LOAD_SUCCESS = "@salesman.load.success";
export const SALESMAN_LOAD_FAIL = "@salesman.load.failure";
export const SALESMAN_CREATE_DONE = "@salesman.load.done";

export const SALESMAN_CREATE_REQUEST = "@salesman.create.request";
export const SALESMAN_CREATE_SUCCESS = "@salesman.create.success";
export const SALESMAN_CREATE_FAIL = "@salesman.create.failure";

export const SALESMAN_UPDATE_REQUEST = "@salesman.update.request";
export const SALESMAN_UPDATE_SUCCESS = "@salesman.update.success";
export const SALESMAN_UPDATE_FAIL = "@salesman.update.failure";
export const SALESMAN_UPDATE_DONE = "@salesman.update.done";
